import { notificationContext } from '@context/notifications';
import { useCallback, useState } from 'react';
import type { Notification } from 'types';
import { v4 as uuidv4 } from 'uuid';

const NotificationsProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const handleAddNotification = useCallback(
    (notification: Notification) => {
      const notificationWithId: Notification = { ...notification, id: notification.id ?? uuidv4() };
      const newNotifications = [...notifications, notificationWithId].sort((n1, n2) => {
        if (n1.priority && !n2.priority) return -1;
        if (!n1.priority && n2.priority) return 1;
        if (n1.priority && n2.priority) return 0;
        else return 0;
      });

      setNotifications(newNotifications);
    },
    [notifications],
  );

  const handleRemoveNotification = useCallback(
    (notification: Notification) => {
      const newNotifications = notifications.filter((n) => n.id !== notification.id);
      setNotifications(newNotifications);
    },
    [notifications],
  );

  return (
    <notificationContext.Provider
      value={{
        notifications,
        notify: handleAddNotification,
        hideNotification: handleRemoveNotification,
      }}
    >
      {children}
    </notificationContext.Provider>
  );
};

export default NotificationsProvider;
